import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ElementRef,
} from '@angular/core';

@Component({
  selector: 'gas-select-option',
  templateUrl: './gas-select-option.component.html',
  styleUrls: ['./gas-select-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasSelectOptionComponent<T = string | number> {
  @Input()
  public value: T;

  public get title(): string {
    const element: HTMLElement = this.elementRef.nativeElement;

    return element.textContent;
  }

  constructor(
    public elementRef: ElementRef,
  ) {}
}
